import { render, staticRenderFns } from "./FattorinoAction.vue?vue&type=template&id=59fbcefc&"
import script from "./FattorinoAction.vue?vue&type=script&lang=ts&"
export * from "./FattorinoAction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports